import i18next from "i18next"
import React, { useEffect } from "react"

const CHART_SRC: Record<string, string> = {
  ru: "https://chart.rsf.ru/clients/sistema/loader.php?app=multchart_ru&target=rsf_informer",
  en: "https://chart.rsf.ru/clients/sistema/loader.php?app=multchart_en&target=rsf_informer",
}

export const Chart: React.FC = () => {
  const currLang = i18next.language
  const chartSrc = CHART_SRC[currLang]

  useEffect(() => {
    const script = document.createElement("script")
    script.src = chartSrc
    script.async = true
    document.body.append(script)
  }, [chartSrc])

  return <div className="d-none d-sm-block" id="rsf_informer" />
}
